import React, {useState} from "react";

import "./SignUpPage.scss";
import {AXIOS} from "../../services/api";
import {Button} from "../../components/button/Button";
import personalInfo from "../../assets/images/add-personal-info.png";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../hooks/useAuth";

function SignUpPage() {
	const [accountName, setAccountName] = useState("");
	const [firstname, setFirstname] = useState("");
	const [lastname, setLastname] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");

	const navigate = useNavigate();
	const {login} = useAuth();

	async function handleRegistration(e) {
		e.preventDefault();
		setError("");
		setIsLoading(true);

		if (!accountName || !firstname || !lastname || !email || !password) {
			setError("Please fill all fields");
			setIsLoading(false);
			return;
		}

		try {
			const response = await AXIOS.post("/accounts", {
				name: accountName,
				firstname,
				lastname,
				email,
				password
			});

			if (response.status === 201) {
				await handleLogin(response?.data?.data);
			}
		} catch (err) {
			setError(err.response?.data?.message || "An error occurred during registration");
		} finally {
			setIsLoading(false);
		}
	}

	async function handleLogin() {
		try {
			const response = await AXIOS.post("/login", {email, password});
			if (response.status === 200) {
				await login(response?.data?.data);
			}
		} catch (err) {
			setError("An error occurred during login");
		}
	}

	return (
		<div className="sign-up-page">
			<div className="container">
				<div className="sign-up-form">
					<div className="form-header">
						<h1>Create Your Account</h1>
						<p>Join our community of app developers</p>
					</div>

					<form onSubmit={handleRegistration}>
						<div className="form-group">
							<label htmlFor="accountName">Account Name</label>
							<input
								type="text"
								id="accountName"
								value={accountName}
								onChange={(e) => setAccountName(e.target.value)}
								placeholder="Enter your account name"
								required
							/>
						</div>

						<div className="form-row">
							<div className="form-group">
								<label htmlFor="firstName">First Name</label>
								<input
									type="text"
									id="firstName"
									value={firstname}
									onChange={(e) => setFirstname(e.target.value)}
									placeholder="Enter your first name"
									required
								/>
							</div>
							<div className="form-group">
								<label htmlFor="lastName">Last Name</label>
								<input
									type="text"
									id="lastName"
									value={lastname}
									onChange={(e) => setLastname(e.target.value)}
									placeholder="Enter your last name"
									required
								/>
							</div>
						</div>

						<div className="form-group">
							<label htmlFor="email">Email</label>
							<input
								type="email"
								id="email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								placeholder="Enter your email"
								required
							/>
						</div>

						<div className="form-group">
							<label htmlFor="password">Password</label>
							<input
								type="password"
								id="password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								placeholder="Create a password"
								required
							/>
						</div>

						{error && <div className="error-message">{error}</div>}

						<div className="form-actions">
							<Button
								label={isLoading ? "Creating Account..." : "Sign Up"}
								variant="primary"
								type="submit"
								disabled={isLoading}
							/>
						</div>
					</form>

					<div className="sign-in-prompt">
						<p>Already have an account?</p>
						<Button
							label="Sign In"
							variant="secondary"
							onClick={() => navigate("/login", {replace: true})}
						/>
					</div>
				</div>

				<div className="side-container">
					<div className="side-content">
						<img src={personalInfo} alt="App Review Management" />
						<h3>Start Managing Your App Reviews</h3>
						<p>Join thousands of developers who are improving their app store ratings with our intelligent review management system.</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export {SignUpPage}
